import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/creditCard`;

export default {
  async list() {
    let apiUrl = store.state.countrySelected.api;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/list`);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },
  async delete(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/remove?lang=${params.lang}`, params);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
